import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import AnalyticsDateRangeSelector from 'containers/pages/analyticsReport/components/RangeSelectors';
import EmailStatsGraph from './emailStatsGraph';
import CallStatsGraph from './callStatsGraph';
import DemoStatsGraph from './demoStatsGraph';
import TotalStatsGraph from './totalStatsGraph';

const SalesAnalyticsPage: React.FC = () => {
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);

  useEffect(() => {
    // Set the start and end date when the component mounts
    const today = dayjs();
    const sevenDaysAgo = dayjs().subtract(7, 'day');
    setStartDate(sevenDaysAgo);
    setEndDate(today);
  }, []); // Empty dependency array ensures this runs only on component mount

  return (
    <Box sx={{ width: '100%', p: 2 }}>
        <Typography variant="h3" align="center" gutterBottom>
        Sales Analytics
      </Typography>
      <AnalyticsDateRangeSelector
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      {/* 2x2 Grid for graphs */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 4,
        }}
      >
        <Box>
          <Typography variant="h5" align="center" gutterBottom>
            Email Stats
          </Typography>
          <EmailStatsGraph startDate={startDate} endDate={endDate} />
        </Box>
        <Box>
          <Typography variant="h5" align="center" gutterBottom>
            Phone Call Stats
          </Typography>
          <CallStatsGraph startDate={startDate} endDate={endDate} />
        </Box>
        <Box>
          <Typography variant="h5" align="center" gutterBottom>
            Demos Booked
          </Typography>
          <DemoStatsGraph startDate={startDate} endDate={endDate} />
        </Box>
        <Box>
          <Typography variant="h5" align="center" gutterBottom>
            Total Outbound
          </Typography>
          <TotalStatsGraph startDate={startDate} endDate={endDate} />
        </Box>
      </Box>
    </Box>
  );
};

export default SalesAnalyticsPage;
